import { render, staticRenderFns } from "./download-page.vue?vue&type=template&id=093795da&scoped=true&"
import script from "./download-page.vue?vue&type=script&lang=js&"
export * from "./download-page.vue?vue&type=script&lang=js&"
import style0 from "./download-page.vue?vue&type=style&index=0&id=093795da&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093795da",
  null
  
)

export default component.exports